import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { AuthService } from '../services/auth.service';
import { CoreService } from '../services/core.service';

export const authGuard: CanActivateFn | CanMatchFn = () => {
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);
  const coreService = inject(CoreService);

  if (authStore.isAuthenticated()) {
    return true;
  }

  // Routes combine this with notMaintenanceGuard in the same canMatch array,
  // and Angular runs every guard in that array regardless of an earlier one's
  // result (no short-circuit) -- so without this check, an unauthenticated
  // visitor gets hard-redirected to login here even while under maintenance,
  // racing ahead of the maintenance gate rendered at the app root (app.html).
  if (coreService.appConfig()?.maintenance?.partner) {
    return false;
  }

  authService.logout();
  return false;
};
